import styled, { css } from 'styled-components'
import { ProductCard, Slider } from '@sainsburys-tech/bolt'

const StyledSlider = styled(Slider)`
  .carousel__slide {
    justify-content: flex-start;
    height: unset;
    flex-direction: column;

    @media (min-width: ${props => props.theme.size.breakpoint['min-width'].sm}) {
      flex-direction: row;
    }
  }
`
const Link = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 5px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) and (max-width: ${props =>
      props.theme.size.breakpoint['max-width'].md}) {
    max-width: 33%;
  }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].lg}) {
    max-width: 25%;
    ${props =>
      props.itemsPerSlide.itemsPerSlideLg === 3 &&
      css`
        max-width: 33%;
      `}
  }
`
const StyledProductCard = styled(ProductCard)`
  margin: 0 5px;
  min-height: 100%;
`
export { StyledSlider, Link, StyledProductCard }
